import { render, staticRenderFns } from "./AdminSettingKahuna.vue?vue&type=template&id=617fcd09&scoped=true&"
import script from "./AdminSettingKahuna.vue?vue&type=script&lang=js&"
export * from "./AdminSettingKahuna.vue?vue&type=script&lang=js&"
import style0 from "./AdminSettingKahuna.vue?vue&type=style&index=0&id=617fcd09&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617fcd09",
  null
  
)

export default component.exports